<template>
  <div>
    <div class="profile-list-item list-group-item media skeleton">
      <div class="row">
        <div class="col-xs-2">
          <div class="skeleton-circle-xl" style="width: 60px; height: 60px" />
        </div>

        <div class="col-xs-10 col-sm-7">
          <div class="skeleton-part-lg" />

          <div class="row">
            <div class="col-xs-6">
              <div class="skeleton-part-xs skeleton-width-sm" />
              <div class="skeleton-part-xs skeleton-width-md" />
              <div class="skeleton-part-xs skeleton-width-xs" />
            </div>
          </div>
        </div>

        <div class="m-b-10 col-xs-12 visible-xs" />
        <div class="col-sm-2 col-xs-12">
          <div class="skeleton-part-md skeleton-width-md" />
          <div class="skeleton-part-xs skeleton-width-xs" />
          <div class="skeleton-part-xl skeleton-width-lg tw-shadow tw-bg-white" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-xs-12">
          <div class="skills">
            <div class="skeleton-part-sm" style="width: 16%; background: #777" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisplaySkeleton',
  props: {},
  data() {
    return {}
  },
  created() {},
}
</script>

<style scoped lang="scss">
.skeleton {
  border-radius: 0;
  border-top: 0;
}
</style>
